import { FirebaseApp, initializeApp } from 'firebase/app';
import { initAnalytics } from './analytics';
import { initMessaging } from './messaging';
import { firebaseConfig } from './util';

let app: FirebaseApp;

const initFirebase = () => {
    app = initializeApp(firebaseConfig);
    initMessaging(app);
    initAnalytics(app);
};

initFirebase();
